import React from "react";
import styled from "styled-components";
import cx from "classnames";
import { UnStyledButton } from "../textButton";

const _Radio = ({className, checked, onClick, role, ariaChecked, ariaLabel, ariaLabelledBy}) => (
  <UnStyledButton
    onClick={onClick}
    className={className}
    role={role}
    aria-checked={ariaChecked}
    aria-label={ariaLabel}
    aria-labelledby={ariaLabelledBy}
  >
    <svg viewBox="0 0 250 250" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="125" cy="125" r="74" fill="#003A3D" className={cx("inner-circle", {checked})} />
      <circle cx="125" cy="125" r="120" stroke="#003A3D" strokeWidth="10" />
    </svg>
  </UnStyledButton>
);
export const Radio = styled(_Radio).attrs(({checked, onClick, role, "aria-checked": ariaChecked, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy}) => ({
  checked,
  onClick,
  role,
  ariaChecked,
  ariaLabel,
  ariaLabelledBy
}))`
  .inner-circle {
    display: none;
    
    &.checked {
      display: block;
    }
  }
`;